import {useBatchMultiple} from "../@hooks";
import {Box} from "@mui/material";
import {ButtonIconSeeker} from "@ui-seeker/core";
import React from "react";

export default function ExecutionToolbarSelect({ selectedData, setSelectedRows }){
    const { handleStopMultipleExecutions } = useBatchMultiple(selectedData, setSelectedRows)

    return <Box sx={{ mr: 2 }}>
        <ButtonIconSeeker
            icon="circle-stop"
            iconWeight="light"
            tooltip="Stop multiple executions"
            onClick={handleStopMultipleExecutions}
        />
    </Box>
}